/* rola.pet — kalkulator wagi i wielkości psa: silnik obliczeń + obsługa formularza.
   Zero zależności, zero zapytań sieciowych. Liczby modelu pochodzą z rola-growth-data.js
   (musi być załadowany PRZED tym plikiem). Działa z trybem quizu (rola-quiz.js) i bez niego. */
(function(root){
  "use strict";

  var DATA = root.ROLA_GROWTH_DATA;
  if(!DATA) return;
  var DAY = 864e5;

  /* ================================================================
     POMOCNICZE
     ================================================================ */
  function fmt(n, dec){
    return Number(n).toLocaleString("pl-PL", {minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0});
  }
  function kg(n){ return fmt(n, n % 1 ? 1 : 0); }
  function kgR(n){ return fmt(n, n < 10 ? 1 : 0); }
  function parseNum(v){
    if(v === null || v === undefined) return null;
    var n = parseFloat(String(v).replace(",", ".").replace(/\s/g, ""));
    return isFinite(n) ? n : null;
  }
  function parseDate(s){
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || "");
    if(!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3], 12, 0, 0);
    return isNaN(d.getTime()) ? null : d;
  }
  function pad(n){ return (n < 10 ? "0" : "") + n; }
  function iso(d){ return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()); }
  function daysBetween(a, b){ return Math.round((b.getTime() - a.getTime()) / DAY); }
  function addDays(d, n){ var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function today(){ var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 12, 0, 0); }
  function longDate(d){ return d.toLocaleDateString("pl-PL", {day: "numeric", month: "long", year: "numeric"}); }
  function shortDate(d){ return d.toLocaleDateString("pl-PL", {day: "numeric", month: "short", year: "numeric"}); }

  function ageLabel(days){
    var weeks = days / 7;
    if(weeks < 26) return Math.round(weeks) + " tyg.";
    var months = Math.round(days / 30.44);
    if(months < 24) return months + " mies.";
    var y = Math.floor(months / 12), mm = months % 12;
    return y + (y === 1 ? " rok" : " lata") + (mm ? " " + mm + " mies." : "");
  }

  function catByKey(k){
    for(var i = 0; i < DATA.categories.length; i++) if(DATA.categories[i].key === k) return DATA.categories[i];
    return null;
  }
  function catForWeight(w){
    var cats = DATA.categories;
    for(var i = 0; i < cats.length - 1; i++) if(w < cats[i].range[1]) return cats[i].key;
    return cats[cats.length - 1].key;
  }
  function forecastKeys(){
    return DATA.categories.filter(function(c){ return !c.noForecast; }).map(function(c){ return c.key; });
  }

  /* ułamek wagi dorosłej dla kategorii i wieku (tygodnie) */
  function frac(key, weeks){
    var pts = DATA.curves[key];
    if(!pts || !pts.length) return null;
    if(weeks <= pts[0][0]) return pts[0][1] * Math.max(weeks, 0) / pts[0][0];
    var last = pts[pts.length - 1];
    if(weeks >= last[0]) return last[1];
    for(var i = 1; i < pts.length; i++){
      if(weeks <= pts[i][0]){
        var a = pts[i - 1], b = pts[i];
        return a[1] + (b[1] - a[1]) * (weeks - a[0]) / (b[0] - a[0]);
      }
    }
    return last[1];
  }

  /* ================================================================
     SILNIK
     ================================================================ */

  /* sesje pomiarowe: pomiary z jednego dnia = jedna sesja (średnia wagi) */
  function buildSessions(input){
    var byDay = {};
    input.measurements.forEach(function(m){
      var k = iso(m.date);
      (byDay[k] = byDay[k] || []).push(m.weight);
    });
    var out = [];
    Object.keys(byDay).sort().forEach(function(k){
      var ws = byDay[k];
      var w = ws.reduce(function(a, b){ return a + b; }, 0) / ws.length;
      var d = parseDate(k);
      var age = input.dob ? daysBetween(input.dob, d) : input.refAgeDays + daysBetween(input.refDate, d);
      out.push({key: k, date: d, weight: w, ageDays: age, weeks: age / 7, n: ws.length});
    });
    return out;
  }

  /* ile pomiarów liczy się jako niezależne (min. odstęp między ważeniami) */
  function effectiveSessions(list){
    var n = 0, lastDate = null;
    list.forEach(function(s){
      if(lastDate === null || daysBetween(lastDate, s.date) >= DATA.minSessionGapDays){
        n++; lastDate = s.date;
      }
    });
    return n;
  }

  /* oszacowanie wagi dorosłej dla kategorii: średnia ważona (późniejsze pomiary mają większą wagę) */
  function estimateFor(key, sessions){
    var num = 0, den = 0, list = [];
    sessions.forEach(function(s){
      var f = frac(key, s.weeks);
      if(!f || f <= 0) return;
      var e = s.weight / f, wt = f * f;
      num += e * wt; den += wt; list.push(e);
    });
    return den ? {est: num / den, list: list} : null;
  }

  function evaluate(key, sessions, range){
    var e = estimateFor(key, sessions);
    if(!e) return null;
    var tol = DATA.tolerance;
    var r = range || catByKey(key).range;
    var mid = (r[0] + r[1]) / 2, width = Math.max(r[1] - r[0], 0.0001);
    return {
      key: key, est: e.est, list: e.list,
      ok: e.est >= r[0] * (1 - tol) && e.est <= r[1] * (1 + tol),
      dist: Math.abs(e.est - mid) / width
    };
  }

  /* skąd znamy oczekiwany rozmiar: rasa / rodzice / kategoria / nieznany */
  function priorFor(input){
    function fromRange(lo, hi, kind){
      var mid = (lo + hi) / 2, k = catForWeight(mid);
      return {kind: kind, range: [lo, hi], cats: [k], giant: !!catByKey(k).noForecast};
    }
    if(input.method === "pure" && input.breed) return fromRange(input.breed.r[0], input.breed.r[1], "breed");
    if(input.method === "mixed"){
      var p = (input.parents || []).filter(function(x){ return x; });
      if(p.length === 1) return fromRange(p[0] * 0.85, p[0] * 1.15, "parents");
      if(p.length >= 2) return fromRange(Math.min(p[0], p[1]) * 0.9, Math.max(p[0], p[1]) * 1.1, "parents");
    }
    if(input.method === "size" && input.sizeKey){
      var c = catByKey(input.sizeKey);
      return {kind: "size", range: c.range, cats: [c.key], giant: !!c.noForecast};
    }
    return {kind: "unknown", range: null, cats: forecastKeys(), giant: false};
  }

  function nextWeighing(latest, matureHiMonths){
    if(matureHiMonths && latest.ageDays >= matureHiMonths * 30.44) return null;
    var d = 56;
    for(var i = 0; i < DATA.nextWeighing.length; i++){
      if(latest.weeks < DATA.nextWeighing[i].maxWeeks){ d = DATA.nextWeighing[i].days; break; }
    }
    return {days: d, date: addDays(latest.date, d)};
  }

  function roundRange(lo, hi){
    var step = hi >= 10 ? 1 : 0.5;
    lo = Math.floor(lo / step) * step;
    hi = Math.ceil(hi / step) * step;
    if(hi - lo < step) hi = lo + step;
    return [Math.max(lo, 0), hi];
  }

  function compute(input){
    var sessions = buildSessions(input);
    if(!sessions.length) return {mode: "invalid"};
    var latest = sessions[sessions.length - 1];
    var res = {sessions: sessions, latest: latest, exactAge: input.ageExact !== undefined ? !!input.ageExact : !!input.dob, warns: [], mode: "forecast", typedBreed: input.typedBreed || null};

    if(latest.ageDays < DATA.minAgeDays){ res.mode = "educational"; return res; }
    if(latest.ageDays > DATA.maxAgeDays){ res.mode = "adult"; return res; }

    var est = sessions.filter(function(s){ return s.ageDays >= DATA.minAgeDays; });
    var prior = priorFor(input);
    res.prior = prior;

    /* psy olbrzymie (>40 kg): brak standardowej prognozy */
    if(prior.giant){
      res.mode = "giant";
      res.cats = [prior.cats[0]];
      res.confidence = "low";
      res.next = nextWeighing(latest, catByKey(prior.cats[0]).matureMonths[1]);
      res.sessionsCount = effectiveSessions(est);
      return res;
    }

    var evals, mismatch = false, noFit = false;
    var range = prior.range;
    if(prior.kind === "unknown"){
      evals = prior.cats.map(function(k){ return evaluate(k, est); }).filter(Boolean);
      var okU = evals.filter(function(e){ return e.ok; });
      if(okU.length) evals = okU; else noFit = true;
    } else {
      var own = evaluate(prior.cats[0], est, range);
      if(own && own.ok){
        evals = [own];
      } else {
        /* skrajna niezgodność (np. 8,5 kg u yorkshire terriera): bez prognozy, prośba o sprawdzenie danych */
        if(own){
          var sev = own.est > range[1] * DATA.severe.high ? "high" : (own.est < range[0] * DATA.severe.low ? "low" : null);
          if(sev){
            var fS = frac(prior.cats[0], latest.weeks);
            res.mode = "check";
            res.confidence = "low";
            res.severe = {
              kind: sev, est: own.est, priorKind: prior.kind, range: range,
              name: input.breed ? input.breed.n : null,
              expected: [range[0] * fS, range[1] * fS]
            };
            return res;
          }
        }
        mismatch = true;
        var all = forecastKeys().map(function(k){ return evaluate(k, est); }).filter(function(e){ return e && e.ok; });
        if(all.length) evals = all; else { evals = own ? [own] : []; noFit = true; }
      }
    }
    if(!evals.length){ res.mode = "invalid"; return res; }

    /* kategoria najbardziej prawdopodobna: oszacowanie najbliżej środka zakresu */
    evals.sort(function(a, b){ return a.dist - b.dist; });
    var likely = evals[0];
    res.likely = likely.key;
    res.cats = evals.map(function(e){ return e.key; });

    /* pewność */
    var effN = effectiveSessions(est);
    res.sessionsCount = effN;
    var knownSize = prior.kind !== "unknown" && !mismatch && !noFit && evals.length === 1;
    var level = "low";
    if(res.exactAge && knownSize && effN >= 2) level = "medium";
    if(DATA.validated && res.exactAge && knownSize && effN >= 3) level = "high";
    res.knownSize = knownSize;
    res.mismatch = mismatch || noFit;

    /* kontrola skoku wagi między kolejnymi sesjami (jakość pomiaru, nie ocena zdrowia) */
    for(var i = 1; i < est.length; i++){
      var a = est[i - 1], b = est[i];
      if(daysBetween(a.date, b.date) < DATA.jump.minGapDays) continue;
      var fa = frac(likely.key, a.weeks), fb = frac(likely.key, b.weeks);
      if(!fa || !fb) continue;
      var r = (b.weight / a.weight) / (fb / fa);
      if(r < DATA.jump.low || r > DATA.jump.high){ res.jump = {from: a, to: b}; break; }
    }

    /* alerty trajektorii (tylko przy zwalidowanym modelu) */
    if(DATA.alertsEnabled && effN >= DATA.trajectory.minSessions && evals.length === 1){
      var first = est[0], last = est[est.length - 1];
      var ef = first.weight / frac(likely.key, first.weeks);
      var el = last.weight / frac(likely.key, last.weeks);
      var ratio = el / ef;
      if(ratio < DATA.trajectory.low) res.trajectory = "slow";
      else if(ratio > DATA.trajectory.high) res.trajectory = "fast";
    }

    if(mismatch || noFit || res.jump) level = "low";
    res.confidence = level;

    /* zakres wyniku */
    var s = DATA.spread[level];
    var cv = 0;
    if(likely.list.length > 1){
      var mean = likely.list.reduce(function(a, b){ return a + b; }, 0) / likely.list.length;
      var variance = likely.list.reduce(function(a, b){ return a + (b - mean) * (b - mean); }, 0) / likely.list.length;
      cv = Math.sqrt(variance) / mean;
    }
    s = Math.min(0.3, Math.max(s, cv));
    var lo = Infinity, hi = -Infinity;
    evals.forEach(function(e){ lo = Math.min(lo, e.est * (1 - s)); hi = Math.max(hi, e.est * (1 + s)); });

    /* zawężenie do wiarygodnego zakresu rasy/rodziców/kategorii (tylko gdy się zgadza) */
    if(knownSize && range){
      var nlo = Math.max(lo, range[0] * 0.9), nhi = Math.min(hi, range[1] * 1.1);
      if(nlo < nhi){ lo = nlo; hi = nhi; }
    }
    var rr = roundRange(lo, hi);
    res.adult = {lo: rr[0], hi: rr[1]};
    res.curve = {key: likely.key, lo: lo, mid: likely.est, hi: hi};

    /* ryzyko, że to pies olbrzymi */
    res.giantRisk = evals.some(function(e){ return e.est >= 36; }) && (prior.kind === "unknown" || res.mismatch);

    /* koniec wzrostu */
    var mLo = Infinity, mHi = -Infinity;
    evals.forEach(function(e){
      var m = catByKey(e.key).matureMonths;
      mLo = Math.min(mLo, m[0]); mHi = Math.max(mHi, m[1]);
    });
    res.mature = {lo: mLo, hi: mHi, done: latest.ageDays >= mHi * 30.44};
    res.next = nextWeighing(latest, mHi);
    return res;
  }

  root.RolaGrowthEngine = {
    compute: compute, frac: frac, catForWeight: catForWeight, effectiveSessions: effectiveSessions,
    ageLabel: ageLabel, parseNum: parseNum, parseDate: parseDate
  };

  if(typeof document === "undefined") return;

  /* ================================================================
     WYKRES (SVG)
     ================================================================ */
  function niceStep(maxV){
    var raw = maxV / 4;
    var pow = Math.pow(10, Math.floor(Math.log(raw) / Math.LN10));
    var n = raw / pow;
    return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * pow;
  }

  function chartSvg(res){
    var W = 640, H = 300, L = 46, R = 14, T = 16, B = 38;
    var xMax = 104;
    var maxPoint = 0;
    res.sessions.forEach(function(s){ maxPoint = Math.max(maxPoint, s.weight); });
    var curve = res.curve;
    var maxCurve = curve ? curve.hi : 0;
    var yMax = Math.max(maxCurve * 1.06, maxPoint * 1.25, 1);
    var step = niceStep(yMax);
    yMax = Math.ceil(yMax / step) * step;
    function X(w){ return L + (Math.min(w, xMax) / xMax) * (W - L - R); }
    function Y(v){ return T + (1 - v / yMax) * (H - T - B); }

    var out = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="100%" role="img" aria-label="Wykres wzrostu: Twoje ważenia na tle prognozowanej krzywej wzrostu" style="display:block;max-width:100%;height:auto">';
    /* siatka i oś Y */
    for(var v = 0; v <= yMax + 0.0001; v += step){
      out += '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + Y(v).toFixed(1) + '" y2="' + Y(v).toFixed(1) + '" style="stroke:var(--rc-line)" stroke-dasharray="3 4"/>';
      out += '<text x="' + (L - 8) + '" y="' + (Y(v) + 4).toFixed(1) + '" text-anchor="end" font-size="11" style="fill:var(--rc-muted)">' + fmt(v, step < 1 ? 1 : 0) + '</text>';
    }
    out += '<text x="' + L + '" y="10" font-size="11" font-weight="700" style="fill:var(--rc-muted)">kg</text>';
    /* oś X */
    var ticks = [[0, "0"], [13, "3 mies."], [26, "6 mies."], [52, "1 rok"], [78, "1,5 roku"], [104, "2 lata"]];
    ticks.forEach(function(t){
      out += '<text x="' + X(t[0]).toFixed(1) + '" y="' + (H - 14) + '" text-anchor="middle" font-size="11" style="fill:var(--rc-muted)">' + t[1] + '</text>';
    });

    if(curve){
      var pts = [], w;
      for(w = 8; w <= xMax; w += 2) pts.push(w);
      function line(scale){
        return pts.map(function(x){ return X(x).toFixed(1) + "," + Y(scale * frac(curve.key, x)).toFixed(1); });
      }
      var hiL = line(curve.hi), loL = line(curve.lo), midL = line(curve.mid);
      var band = hiL.concat(loL.slice().reverse()).join(" ");
      out += '<polygon points="' + band + '" style="fill:var(--rc-accent);opacity:.45"/>';
      out += '<polyline points="' + midL.join(" ") + '" fill="none" stroke-width="2" style="stroke:var(--rc-ink)"/>';
      if(res.mature){
        var mw = res.mature.hi * 4.345;
        out += '<line x1="' + X(mw).toFixed(1) + '" x2="' + X(mw).toFixed(1) + '" y1="' + T + '" y2="' + (H - B) + '" stroke-width="1.5" stroke-dasharray="5 4" style="stroke:var(--rc-ink);opacity:.5"/>';
        out += '<text x="' + (X(mw) - 6).toFixed(1) + '" y="' + (T + 12) + '" text-anchor="end" font-size="11" style="fill:var(--rc-muted)">koniec wzrostu</text>';
      }
    }
    /* punkty pomiarów */
    res.sessions.forEach(function(s){
      if(s.weeks < 0) return;
      out += '<circle cx="' + X(s.weeks).toFixed(1) + '" cy="' + Y(s.weight).toFixed(1) + '" r="6" stroke-width="2.5" style="fill:var(--rc-accent);stroke:var(--rc-ink)"/>';
    });
    out += '</svg>';
    return out;
  }

  /* ================================================================
     FORMULARZ
     ================================================================ */
  function init(rootEl){
    var $ = function(s){ return rootEl.querySelector(s); };
    var $$ = function(s){ return Array.prototype.slice.call(rootEl.querySelectorAll(s)); };
    var scope = rootEl.closest("[data-rc-scope]") || rootEl.parentNode;

    var el = {
      dob: $("[data-g-dob]"), ageKnown: $("[data-g-age-known]"), ageNotice: $("[data-g-age-notice]"), weightHint: $("[data-g-weight-hint]"),
      ageN: $("[data-g-age-n]"), ageUnit: $("[data-g-age-unit]"),
      ageExact: $("[data-g-age-exact]"), ageEst: $("[data-g-age-est]"),
      weight: $("[data-g-weight]"), wdate: $("[data-g-wdate]"),
      prevDate: $("[data-g-prev-date]"), prevWeight: $("[data-g-prev-weight]"),
      skipBreed: $("[data-g-skip-breed]"), breed: $("[data-g-breed]"), breedHint: $("[data-g-breed-hint]"), breedList: $("[data-g-breeds]"),
      momKg: $("[data-g-parent-a]"), dadKg: $("[data-g-parent-b]"),
      sizes: $("[data-g-sizes]"),
      addDate: $("[data-g-add-date]"), addWeight: $("[data-g-add-weight]"), addBtn: $("[data-g-add]"), addErr: $("[data-g-add-err]"),
      meas: $("[data-g-meas]"), chart: $("[data-g-chart]"),
      content: $("[data-g-content]"), empty: $("[data-g-empty]"),
      share: $("[data-g-share]"), toast: $("[data-g-toast]")
    };
    var extras = [];
    var lastResult = null;
    var uid = Math.random().toString(36).slice(2, 7);
    var T = today(), todayIso = iso(T);

    /* --- inicjalizacja pól --- */
    [el.dob, el.wdate, el.prevDate, el.addDate].forEach(function(i){ if(i) i.max = todayIso; });
    if(el.wdate && !el.wdate.value) el.wdate.value = todayIso;
    if(el.addDate && !el.addDate.value) el.addDate.value = todayIso;

    DATA.breeds.forEach(function(b){
      var o = document.createElement("option");
      o.value = b.n;
      el.breedList.appendChild(o);
    });

    /* karty kategorii (z konfiguracji) */
    DATA.categories.forEach(function(c){
      var rng = c.noForecast ? "powyżej " + kg(c.range[0]) + " kg" : (c.key === "toy" ? "do " + kg(c.range[1]) + " kg" : kg(c.range[0]) + "–" + kg(c.range[1]) + " kg");
      var lab = document.createElement("label");
      lab.className = "rc-opt";
      var input = document.createElement("input");
      input.type = "radio"; input.name = "rg-size-" + uid; input.value = c.key; input.setAttribute("data-g-size", "");
      var wrap = document.createElement("span"); wrap.className = "rc-opt-in";
      var txt = document.createElement("span"); txt.className = "rc-opt-txt";
      var nm = document.createElement("span"); nm.className = "rc-opt-name"; nm.textContent = c.label + " · " + rng;
      var ds = document.createElement("span"); ds.className = "rc-opt-desc"; ds.textContent = c.ex;
      txt.appendChild(nm); txt.appendChild(ds); wrap.appendChild(txt);
      lab.appendChild(input); lab.appendChild(wrap);
      el.sizes.appendChild(lab);
    });

    function method(){
      var r = $$("[data-g-method]").filter(function(x){ return x.checked; })[0];
      return r ? r.value : "pure";
    }
    function sexVal(){
      var r = $$("[data-g-sex]").filter(function(x){ return x.checked; })[0];
      return r ? r.value : "unknown";
    }
    function sizeVal(){
      var r = $$("[data-g-size]").filter(function(x){ return x.checked; })[0];
      return r ? r.value : null;
    }
    function findBreed(){
      var v = (el.breed.value || "").trim().toLowerCase();
      if(!v) return null;
      for(var i = 0; i < DATA.breeds.length; i++) if(DATA.breeds[i].n.toLowerCase() === v) return DATA.breeds[i];
      var hits = DATA.breeds.filter(function(b){ return b.n.toLowerCase().indexOf(v) === 0; });
      return hits.length === 1 ? hits[0] : null;
    }

    /* --- odczyt i walidacja (używane też przez tryb quizu) --- */
    function readAge(){
      if(el.ageKnown.checked){
        var d = parseDate(el.dob.value);
        if(!d) return {ok: false, msg: "Podaj datę urodzenia psa albo odznacz „Znam dokładną datę urodzenia” i wpisz przybliżony wiek.", el: el.dob};
        if(d.getTime() > T.getTime()) return {ok: false, msg: "Data urodzenia nie może być z przyszłości.", el: el.dob};
        return {ok: true, dob: d, exact: true};
      }
      var n = parseNum(el.ageN.value);
      if(n === null || n <= 0) return {ok: false, msg: "Podaj przybliżony wiek psa.", el: el.ageN};
      var days = el.ageUnit.value === "m" ? n * 30.44 : n * 7;
      if(days < 7 || days > 1100) return {ok: false, msg: "Podaj wiek w sensownym zakresie (od 1 tygodnia do 3 lat).", el: el.ageN};
      return {ok: true, ageDays: Math.round(days), exact: el.ageUnit.value === "w"};
    }

    function readWeights(age){
      var w = parseNum(el.weight.value);
      if(w === null || w <= 0) return {ok: false, msg: "Podaj aktualną wagę psa w kilogramach.", el: el.weight};
      if(w < 0.2 || w > 100) return {ok: false, msg: "Waga powinna mieścić się między 0,2 a 100 kg. Sprawdź, czy podajesz kilogramy.", el: el.weight};
      var d = parseDate(el.wdate.value);
      if(!d) return {ok: false, msg: "Podaj datę ważenia.", el: el.wdate};
      if(d.getTime() > T.getTime()) return {ok: false, msg: "Data ważenia nie może być z przyszłości.", el: el.wdate};
      if(age && age.dob && d.getTime() < age.dob.getTime()) return {ok: false, msg: "Data ważenia jest wcześniejsza niż data urodzenia.", el: el.wdate};
      var list = [{date: d, weight: w}];

      var pd = el.prevDate.value, pw = el.prevWeight.value;
      if(pd || String(pw).trim()){
        var prevD = parseDate(pd), prevW = parseNum(pw);
        if(!prevD || prevW === null) return {ok: false, msg: "Wcześniejsze ważenie: podaj i datę, i wagę (albo wyczyść oba pola).", el: !prevD ? el.prevDate : el.prevWeight};
        if(prevW < 0.2 || prevW > 100) return {ok: false, msg: "Wcześniejsze ważenie: waga powinna mieścić się między 0,2 a 100 kg.", el: el.prevWeight};
        if(prevD.getTime() > T.getTime()) return {ok: false, msg: "Wcześniejsze ważenie nie może być z przyszłości.", el: el.prevDate};
        if(age && age.dob && prevD.getTime() < age.dob.getTime()) return {ok: false, msg: "Wcześniejsze ważenie jest sprzed urodzenia psa.", el: el.prevDate};
        if(age && !age.dob && age.ageDays + daysBetween(d, prevD) <= 0) return {ok: false, msg: "Wcześniejsze ważenie wypada przed urodzeniem psa — sprawdź daty.", el: el.prevDate};
        list.push({date: prevD, weight: prevW});
      }
      return {ok: true, list: list, current: {date: d, weight: w}};
    }

    function readBreed(){
      var m = method();
      if(m === "pure"){
        var typed = String(el.breed.value || "").trim();
        if(!typed) return {ok: false, msg: "Wpisz nazwę rasy albo kliknij „Nie znam rasy — przejdź dalej”.", el: el.breed};
        var b = findBreed();
        if(b) return {ok: true, method: m, breed: b};
        /* „nie wiem”, „mieszaniec” itp. albo rasa spoza listy: nie blokujemy, pokazujemy możliwy zakres */
        var dontKnow = /^(nie\s*wiem|nie\s*znam|nie\s*pamiętam|brak|\?+|-+|n\/?a|mieszaniec|kundel|kundelek|mix)(\s|$)/i.test(typed);
        return {ok: true, method: "unknown", typedBreed: dontKnow ? null : typed};
      }
      if(m === "mixed"){
        var a = parseNum(el.momKg.value), c = parseNum(el.dadKg.value);
        var okA = a !== null && a >= 1 && a <= 100, okC = c !== null && c >= 1 && c <= 100;
        if(!okA && !okC) return {ok: false, msg: "Podaj przybliżoną wagę choć jednego z rodziców (1–100 kg) albo wybierz inną opcję.", el: el.momKg};
        return {ok: true, method: m, parents: [okA ? a : null, okC ? c : null]};
      }
      if(m === "size"){
        var s = sizeVal();
        if(!s) return {ok: false, msg: "Wybierz kategorię wielkości psa.", el: null};
        return {ok: true, method: m, sizeKey: s};
      }
      return {ok: true, method: "unknown"};
    }

    function buildInput(){
      var age = readAge(); if(!age.ok) return null;
      var wt = readWeights(age); if(!wt.ok) return null;
      var br = readBreed(); if(!br.ok) return null;
      var measurements = wt.list.concat(extras);
      return {
        dob: age.dob || null,
        ageExact: age.exact,
        refAgeDays: age.ageDays || 0,
        refDate: wt.current.date,
        sex: sexVal(),
        method: br.method, breed: br.breed || null, parents: br.parents || null, sizeKey: br.sizeKey || null, typedBreed: br.typedBreed || null,
        measurements: measurements
      };
    }

    /* hak dla trybu quizu: walidacja kroku przed przejściem dalej */
    var stepEls = {};
    $$("[data-g-step]").forEach(function(s){ stepEls[s.getAttribute("data-g-step")] = s; });
    function hook(name, fn){
      if(!stepEls[name]) return;
      stepEls[name].rqValidate = function(){
        var r = fn();
        return r.ok ? true : {msg: r.msg, el: r.el};
      };
    }
    function ageDaysToday(a){ return a.dob ? daysBetween(a.dob, T) : a.ageDays; }
    hook("age", function(){
      var a = readAge();
      if(!a.ok) return a;
      if(ageDaysToday(a) < DATA.minAgeDays) return {ok: false, msg: "Poniżej 8. tygodnia życia nie podajemy prognozy — wróć, gdy szczenię skończy 8 tygodni.", el: null};
      return a;
    });
    hook("weight", function(){ var a = readAge(); return readWeights(a.ok ? a : null); });
    hook("breed", readBreed);

    /* ================================================================
       RENDER
       ================================================================ */
    function setText(sel, txt){ var n = $(sel); if(n) n.textContent = txt; }
    function warn(box, text, hard){
      var d = document.createElement("div");
      d.className = "rc-warn" + (hard ? " rc-warn--hard" : "");
      d.textContent = text;
      box.appendChild(d);
    }
    function catLabels(keys){
      var order = DATA.categories.map(function(c){ return c.key; });
      var sorted = keys.slice().sort(function(a, b){ return order.indexOf(a) - order.indexOf(b); });
      return sorted.map(function(k){ return catByKey(k).label; });
    }

    var CONF = {
      low:    {name: "orientacyjny wynik"},
      medium: {name: "średnia pewność"},
      high:   {name: "wysoka pewność"}
    };

    function renderMeasurements(res){
      el.meas.innerHTML = "";
      res.sessions.forEach(function(s){
        var li = document.createElement("li");
        var info = document.createElement("span");
        info.textContent = shortDate(s.date) + " · " + ageLabel(Math.max(s.ageDays, 0)) + " · " + kg(Math.round(s.weight * 100) / 100) + " kg";
        li.appendChild(info);
        /* usuwać można pomiary dodane ręcznie i poprzednie ważenie */
        var isPrev = el.prevDate.value && s.key === el.prevDate.value;
        var exIdx = -1;
        extras.forEach(function(x, i){ if(iso(x.date) === s.key) exIdx = i; });
        if(exIdx > -1 || isPrev){
          var b = document.createElement("button");
          b.type = "button"; b.className = "rg-x"; b.setAttribute("aria-label", "Usuń to ważenie");
          b.textContent = "×";
          b.setAttribute("data-g-remove", exIdx > -1 ? "x" + exIdx : "prev");
          li.appendChild(b);
        }
        el.meas.appendChild(li);
      });
    }

    function render(res){
      lastResult = res;
      if(!res || res.mode === "invalid"){
        el.content.hidden = true; el.empty.hidden = false;
        return;
      }
      el.content.hidden = false; el.empty.hidden = true;

      var warns = $("[data-g-warns]"); warns.innerHTML = "";
      var latest = res.latest;
      var big = $("[data-g-adult]"), unit = $("[data-g-adult-unit]"), kicker = $("[data-g-kicker]");
      var note = $("[data-g-note]");
      var headline = "Pies w wieku " + (res.exactAge ? "" : "ok. ") + ageLabel(Math.max(latest.ageDays, 0)) + " · " + kg(Math.round(latest.weight * 100) / 100) + " kg";

      kicker.textContent = "Przewidywana waga dorosłego psa";
      $("[data-g-next]").hidden = true;
      var nextBox = $("[data-g-next]");

      if(res.mode === "educational"){
        kicker.textContent = "Za wcześnie na prognozę";
        big.textContent = "—";
        unit.textContent = "poniżej 8. tygodnia życia";
        setText("[data-g-size]", "—"); setText("[data-g-size-sub]", "wymaga starszego szczenięcia");
        setText("[data-g-finish]", "—"); setText("[data-g-finish-sub]", "");
        setText("[data-g-conf]", "—"); setText("[data-g-conf-sub]", "");
        note.textContent = "W pierwszych tygodniach życia szczenię rośnie bardzo szybko, a jego waga zależy od miotu i karmienia przez matkę. Poniżej 8. tygodnia nie podajemy prognozy wagi dorosłej — byłaby zbyt niepewna. Wróć, gdy szczenię skończy 8 tygodni, a w razie wątpliwości co do przyrostów skonsultuj się z lekarzem weterynarii lub hodowcą.";
        headline += " · tryb informacyjny";
      } else if(res.mode === "adult"){
        kicker.textContent = "Pies dorosły";
        big.textContent = "—";
        unit.textContent = "kalkulator dotyczy rosnących psów (do ok. 2 lat)";
        setText("[data-g-size]", "—"); setText("[data-g-size-sub]", "");
        setText("[data-g-finish]", "wzrost zakończony"); setText("[data-g-finish-sub]", "pies ma ponad 2 lata");
        setText("[data-g-conf]", "—"); setText("[data-g-conf-sub]", "");
        note.textContent = "Twój pies jest już dorosły, więc nie przewidujemy dalszego wzrostu. Najważniejsze teraz to utrzymanie prawidłowej masy ciała — sprawdź sylwetkę testem BCS poniżej i dopasuj porcję w kalkulatorze karmienia.";
      } else if(res.mode === "check"){
        var sv = res.severe;
        var ctx = sv.priorKind === "breed" ? "dla rasy " + sv.name : (sv.priorKind === "parents" ? "przy podanej wadze rodziców" : "dla wybranej kategorii wielkości");
        kicker.textContent = "Sprawdź dane";
        big.textContent = "?";
        unit.textContent = "waga bardzo nietypowa dla wybranej rasy lub wielkości";
        setText("[data-g-size]", "—"); setText("[data-g-size-sub]", "nie oceniamy rozmiaru");
        setText("[data-g-finish]", "—"); setText("[data-g-finish-sub]", "");
        setText("[data-g-conf]", "brak wyniku"); setText("[data-g-conf-sub]", "dane wymagają sprawdzenia");
        note.textContent = "Waga " + kg(Math.round(latest.weight * 100) / 100) + " kg w wieku " + (res.exactAge ? "" : "ok. ") + ageLabel(Math.max(latest.ageDays, 0)) +
          " jest dużo " + (sv.kind === "high" ? "wyższa" : "niższa") + " niż oczekiwana " + ctx + ": w tym wieku pies o takiej prognozie waży zwykle ok. " +
          kgR(sv.expected[0]) + "–" + kgR(sv.expected[1]) + " kg (dorosły: " + kgR(sv.range[0]) + "–" + kgR(sv.range[1]) + " kg). " +
          "Przy takiej rozbieżności nie podajemy prognozy, bo byłaby myląca. Sprawdź kolejno: czy waga jest w kilogramach, czy wiek lub data urodzenia są poprawne " +
          "i czy wybrana rasa lub wielkość się zgadza (to może być mieszaniec albo większa rasa — wtedy wybierz „Mieszaniec” lub „Nie wiem”). " +
          "Jeśli dane są prawidłowe, a pies wyraźnie odbiega od typowych wartości, porozmawiaj z lekarzem weterynarii.";
        warn(warns, "Prognoza wstrzymana, bo dane są niespójne. To zabezpieczenie, a nie błąd kalkulatora.", true);
      } else if(res.mode === "giant"){
        var gc = catByKey(res.cats[0]);
        big.textContent = "40+";
        unit.textContent = "kg · brak standardowej prognozy";
        setText("[data-g-size]", gc.label);
        setText("[data-g-size-sub]", res.prior.range && res.prior.kind !== "size" ? "typowo " + kg(res.prior.range[0]) + "–" + kg(res.prior.range[1]) + " kg" : "powyżej " + kg(gc.range[0]) + " kg");
        setText("[data-g-finish]", "do " + gc.matureMonths[0] + "–" + gc.matureMonths[1] + " mies.");
        setText("[data-g-finish-sub]", "psy olbrzymie rosną najdłużej");
        setText("[data-g-conf]", CONF.low.name);
        setText("[data-g-conf-sub]", "dla ras olbrzymich nie ma walidowanej krzywej");
        note.textContent = "Dla psów powyżej 40 kg krzywe wzrostu różnią się bardzo między rasami (np. dog niemiecki i rottweiler rosną zupełnie inaczej), więc nie podajemy prognozy wagi dorosłej. Waż psa co 2 tygodnie, zapisuj wyniki i omawiaj tempo wzrostu z lekarzem weterynarii — u dużych szczeniąt zbyt szybki przyrost obciąża stawy.";
        warn(warns, "Prognoza nie jest dostępna dla ras olbrzymich — to celowe ograniczenie, nie błąd kalkulatora.", false);
      } else {
        /* prognoza */
        var a = res.adult;
        big.textContent = kg(a.lo) + "–" + kg(a.hi);
        unit.textContent = "kg · orientacyjny zakres";
        var labels = catLabels(res.cats);
        var likelyLab = catByKey(res.likely).label;
        if(res.cats.length > 1){
          setText("[data-g-size]", likelyLab);
          setText("[data-g-size-sub]", "możliwy zakres: " + labels.join(" / ") + " — potrzebujemy kolejnych pomiarów, aby zawęzić wynik");
        } else {
          setText("[data-g-size]", likelyLab);
          var cat = catByKey(res.likely);
          setText("[data-g-size-sub]", cat.key === "toy" ? "dorosły do " + kg(cat.range[1]) + " kg" : "dorosły " + kg(cat.range[0]) + "–" + kg(cat.range[1]) + " kg");
        }
        if(res.mature.done){
          setText("[data-g-finish]", "prawdopodobnie zakończony");
          setText("[data-g-finish-sub]", "pies jest w wieku, w którym rośnie już niewiele");
        } else {
          setText("[data-g-finish]", "około " + res.mature.lo + "–" + res.mature.hi + " mies.");
          setText("[data-g-finish-sub]", "wieku życia; im większy pies, tym dłużej rośnie");
        }
        var conf = res.confidence;
        setText("[data-g-conf]", CONF[conf].name);
        var cs;
        if(res.mismatch) cs = "zmierzona waga nie pasuje do wybranej rasy lub wielkości — sprawdź rasę, wiek i pomiar";
        else if(res.jump) cs = "wynik odbiega od oczekiwanego tempa — zważ psa ponownie";
        else if(res.cats.length > 1) cs = "podaj rasę lub wielkość psa, aby zawęzić wynik";
        else if(!res.exactAge) cs = "dokładna data urodzenia zwiększy pewność";
        else if(res.sessionsCount < 2) cs = "potrzebne są jeszcze " + Math.max(1, 3 - res.sessionsCount) + " pomiary (co ok. 2 tygodnie)";
        else if(res.sessionsCount < 3) cs = "kolejne ważenie jeszcze ją zwiększy";
        else cs = DATA.validated ? "wynik oparty na trzech i więcej pomiarach" : "model w wersji orientacyjnej — wynik pozostaje przybliżony";
        setText("[data-g-conf-sub]", cs);

        var msg;
        if(res.mismatch) msg = "Zmierzona waga wyraźnie odbiega od zakresu wybranej rasy lub wielkości, dlatego pokazujemy zakres wynikający z samego pomiaru. Upewnij się, że wiek, rasa i waga są wpisane poprawnie.";
        else if(res.cats.length > 1) msg = "Nie znamy rasy ani wielkości psa, więc pokazujemy szeroki zakres. Wybierz rasę lub wielkość, a dodatkowe ważenie za ok. 2 tygodnie pozwoli go zawęzić.";
        else if(res.sessionsCount < 2) msg = "To wynik z jednego ważenia — traktuj go jako orientacyjny. Prawdziwą trajektorię wzrostu widać dopiero po kilku pomiarach, więc waż szczeniaka regularnie i dodawaj wyniki poniżej.";
        else msg = "Wynik opiera się na " + res.sessionsCount + " ważeniach. Im więcej regularnych pomiarów, tym lepiej widać, jak szczenię faktycznie rośnie.";
        note.textContent = msg;

        if(res.mismatch) warn(warns, "Waga nie pasuje do wybranej rasy/wielkości. Sprawdź wiek, rasę i pomiar (czy waga jest w kilogramach, czy waga nie była zawyżona np. ubraniem lub smyczą).", true);
        if(res.jump) warn(warns, "Zmiana wagi między ważeniami jest nietypowo duża lub mała w porównaniu z oczekiwanym tempem wzrostu. Zważ psa ponownie i sprawdź jednostki — dopiero potem wyciągaj wnioski.", true);
        if(res.trajectory === "fast") warn(warns, "Pies przybiera szybciej niż typowa krzywa tej wielkości. Jeśli tak jest od kilku ważeń, omów to z lekarzem weterynarii (zbyt szybki wzrost obciąża stawy).", true);
        if(res.trajectory === "slow") warn(warns, "Pies przybiera wolniej niż typowa krzywa tej wielkości. Jeśli tak jest od kilku ważeń, skonsultuj to z lekarzem weterynarii.", true);
        if(res.giantRisk) warn(warns, "Przy takiej wadze to może być pies rasy olbrzymiej — dla nich nie ma walidowanych krzywych, więc prognozę traktuj z dużą ostrożnością.", false);
        if(res.typedBreed) warn(warns, "Nie mamy rasy „" + res.typedBreed + "” w naszej liście, więc pokazujemy szeroki zakres. Wybierz wielkość psa (lub wagę rodziców), aby zawęzić wynik.", false);
        if(!res.exactAge) warn(warns, "Wiek jest przybliżony — to obniża pewność wyniku. Jeśli znasz datę urodzenia, podaj ją.", false);
      }

      setText("[data-g-headline]", headline);

      /* następne ważenie */
      if(res.next){
        var due = res.next.date;
        setText("[data-g-next-date]", due.getTime() <= T.getTime() ? "już czas na kolejne ważenie" : longDate(due));
        setText("[data-g-next-note]", latest.weeks < 26
          ? "Do 6. miesiąca życia waż szczeniaka co 2 tygodnie — najlepiej o tej samej porze, przed posiłkiem."
          : (latest.weeks < 52 ? "W tym wieku wystarczy ważyć psa co ok. 4 tygodnie." : "Teraz wystarczy ważyć psa co kilka tygodni."));
        nextBox.hidden = false;
      } else if(res.mode === "forecast" || res.mode === "giant"){
        setText("[data-g-next-date]", "ważenie kontrolne co kilka miesięcy");
        setText("[data-g-next-note]", "Pies jest w wieku, w którym zwykle kończy wzrost — dalej wystarczy kontrolować wagę i sylwetkę (test BCS).");
        nextBox.hidden = false;
      }

      renderMeasurements(res);
      el.chart.innerHTML = chartSvg(res);

      /* wersja modelu */
      var model = $("[data-g-model]");
      if(model){
        model.textContent = DATA.validated
          ? "Wersja modelu: " + DATA.modelVersion + " · źródło danych: " + DATA.sourceVersion + "."
          : "Wersja modelu: " + DATA.modelVersion + " (orientacyjna). Krzywe są uśrednione i nie pochodzą z walidowanych tabel centylowych — dlatego pewność wyniku jest ograniczona, a kalkulator nie wystawia alertów o trajektorii.";
      }

      publish(res);
    }

    function publish(res){
      if(!scope || !scope.setAttribute || !res || res.mode === "invalid") return;
      var catName = res.likely ? catByKey(res.likely).label : (res.cats ? catByKey(res.cats[0]).label : "");
      try {
        scope.setAttribute("data-rc-params", JSON.stringify({
          kalkulator: "wzrost_psa",
          tryb: res.mode,
          wiek_dni: Math.round(res.latest.ageDays),
          waga_kg: Math.round(res.latest.weight * 100) / 100,
          plec: sexVal(),
          kategoria: catName,
          prognoza_kg_od: res.adult ? res.adult.lo : null,
          prognoza_kg_do: res.adult ? res.adult.hi : null,
          pewnosc: res.confidence || null,
          model_version: DATA.modelVersion,
          source_version: DATA.sourceVersion
        }));
      } catch(e){}
      var slots = scope.querySelectorAll("[data-rc-stage-name]");
      for(var i = 0; i < slots.length; i++) slots[i].textContent = catName || "psa";
      scope.setAttribute("data-rc-stage", catName);
    }

    var EDU_TEXT = "Poniżej 8. tygodnia życia szczenię rośnie bardzo szybko, a jego waga zależy od miotu i karmienia przez matkę, więc nie podajemy prognozy wagi dorosłej — byłaby zbyt niepewna. Wróć, gdy szczenię skończy 8 tygodni; w razie wątpliwości co do przyrostów skonsultuj się z lekarzem weterynarii lub hodowcą.";
    var ADULT_TEXT = "Pies po 2. roku życia jest już dorosły — kalkulator nie przewiduje dalszego wzrostu. Możesz kontynuować, aby zobaczyć wskazówki dotyczące sylwetki i karmienia.";

    function expectedHint(){
      var age = readAge(); if(!age.ok) return "";
      var br = readBreed(); if(!br.ok || br.method === "unknown") return "";
      var wd = parseDate(el.wdate.value) || T;
      var ageDays = age.dob ? daysBetween(age.dob, wd) : age.ageDays;
      if(ageDays < DATA.minAgeDays || ageDays > DATA.maxAgeDays) return "";
      var prior = priorFor({method: br.method, breed: br.breed, parents: br.parents, sizeKey: br.sizeKey});
      if(!prior.range || prior.giant) return "";
      var f = frac(prior.cats[0], ageDays / 7);
      if(!f) return "";
      return "Orientacyjnie szczenię tej wielkości w tym wieku waży ok. " + kgR(prior.range[0] * f) + "–" + kgR(prior.range[1] * f) + " kg.";
    }

    function update(){
      /* widoczność pól zależnych */
      el.ageExact.hidden = !el.ageKnown.checked;
      el.ageEst.hidden = el.ageKnown.checked;
      /* komunikat od razu przy wieku (nie dopiero w wyniku) */
      var an = readAge(), notice = "";
      if(an.ok){
        var dn = an.dob ? daysBetween(an.dob, T) : an.ageDays;
        if(dn < DATA.minAgeDays) notice = EDU_TEXT; else if(dn > DATA.maxAgeDays) notice = ADULT_TEXT;
      }
      el.ageNotice.textContent = notice; el.ageNotice.hidden = !notice;
      var m = method();
      $$("[data-g-sub]").forEach(function(s){ s.hidden = s.getAttribute("data-g-sub") !== m; });
      if(el.skipBreed) el.skipBreed.hidden = (m === "unknown");
      /* podpowiedź rasy */
      var input = buildInput();
      var res = input ? compute(input) : null;
      var b = findBreed();
      if(el.breedHint){
        el.breedHint.textContent = !el.breed.value.trim() ? "Zacznij pisać nazwę rasy i wybierz ją z listy."
          : (b ? "Typowa waga dorosłego psa tej rasy: " + kg(b.r[0]) + "–" + kg(b.r[1]) + " kg." : "Nie mamy takiej rasy na liście — nie szkodzi. Kliknij „Dalej”, a pokażemy możliwy zakres (albo wybierz wielkość psa powyżej).");
      }
      /* przy wadze: orientacyjna waga w tym wieku albo ostrzeżenie o skrajnej niezgodności */
      if(el.weightHint){
        var wtxt = "", wwarn = false;
        if(res && res.mode === "check" && res.severe){
          wtxt = "⚠ Waga " + kg(Math.round(res.latest.weight * 100) / 100) + " kg jest bardzo nietypowa dla wybranej rasy lub wielkości w tym wieku (oczekiwane ok. " +
            kgR(res.severe.expected[0]) + "–" + kgR(res.severe.expected[1]) + " kg). Sprawdź wiek, wagę i rasę — przy takiej rozbieżności nie podamy prognozy.";
          wwarn = true;
        } else {
          wtxt = expectedHint();
        }
        el.weightHint.textContent = wtxt;
        el.weightHint.hidden = !wtxt;
        el.weightHint.classList.toggle("rg-hint-warn", wwarn);
      }
      render(res);
    }

    /* --- zdarzenia --- */
    rootEl.addEventListener("input", function(e){
      if(e.target && e.target.hasAttribute && (e.target.hasAttribute("data-g-add-date") || e.target.hasAttribute("data-g-add-weight"))) return;
      update();
    });
    rootEl.addEventListener("change", function(e){
      if(e.target && e.target.hasAttribute && (e.target.hasAttribute("data-g-add-date") || e.target.hasAttribute("data-g-add-weight"))) return;
      $$(".rc-opt").forEach(function(o){
        var inp = o.querySelector("input[type=radio]");
        if(inp) o.classList.toggle("is-on", inp.checked);
      });
      update();
    });

    function addErr(msg){ el.addErr.textContent = msg; el.addErr.hidden = !msg; }
    el.addBtn.addEventListener("click", function(){
      addErr("");
      var age = readAge();
      var d = parseDate(el.addDate.value), w = parseNum(el.addWeight.value);
      if(!d) return addErr("Podaj datę ważenia.");
      if(d.getTime() > T.getTime()) return addErr("Data ważenia nie może być z przyszłości.");
      if(w === null || w < 0.2 || w > 100) return addErr("Podaj wagę w kilogramach (0,2–100 kg).");
      if(age.ok && age.dob && d.getTime() < age.dob.getTime()) return addErr("Data ważenia jest wcześniejsza niż data urodzenia.");
      if(age.ok && !age.dob){
        var curr = parseDate(el.wdate.value);
        if(curr && age.ageDays + daysBetween(curr, d) <= 0) return addErr("Ta data wypada przed urodzeniem psa — sprawdź daty.");
      }
      extras.push({date: d, weight: w});
      el.addWeight.value = "";
      update();
    });

    el.meas.addEventListener("click", function(e){
      var b = e.target.closest ? e.target.closest("[data-g-remove]") : null;
      if(!b) return;
      var what = b.getAttribute("data-g-remove");
      if(what === "prev"){ el.prevDate.value = ""; el.prevWeight.value = ""; }
      else extras.splice(parseInt(what.slice(1), 10), 1);
      update();
    });

    function fireEvent(name){
      var ev;
      try { ev = new CustomEvent(name, {bubbles: true}); }
      catch(e){ ev = document.createEvent("CustomEvent"); ev.initCustomEvent(name, true, false, null); }
      scope.dispatchEvent(ev);
    }
    if(el.skipBreed) el.skipBreed.addEventListener("click", function(){
      var r = $$("[data-g-method]").filter(function(x){ return x.value === "unknown"; })[0];
      if(r){ r.checked = true; r.dispatchEvent(new Event("change", {bubbles: true})); }
      if(scope.hasAttribute("data-quiz")) fireEvent("rq:next");
    });

    function toast(msg){
      if(!el.toast) return;
      el.toast.textContent = msg; el.toast.hidden = false;
      clearTimeout(toast._t);
      toast._t = setTimeout(function(){ el.toast.hidden = true; }, 3500);
    }
    function shareText(){
      var r = lastResult;
      if(!r || !r.latest) return "";
      var t = "Kalkulator wagi i wielkości psa (rola.pet). Pies: " + (r.exactAge ? "" : "ok. ") + ageLabel(Math.max(r.latest.ageDays, 0)) + ", " + kg(Math.round(r.latest.weight * 100) / 100) + " kg.";
      if(r.adult) t += " Przewidywana waga dorosłego psa: " + kg(r.adult.lo) + "–" + kg(r.adult.hi) + " kg (orientacyjnie).";
      return t;
    }
    if(el.share) el.share.addEventListener("click", function(){
      var text = shareText();
      if(!text) return;
      var url = location.href.split("#")[0];
      if(window.dataLayer) window.dataLayer.push({event: "rola_calc_share", rola_feature: "growth_calculator"});
      if(navigator.share){
        navigator.share({title: "Wynik: waga dorosłego psa", text: text, url: url}).catch(function(){});
        return;
      }
      var full = text + " " + url;
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(full).then(function(){ toast("Skopiowano wynik do schowka."); }, function(){ window.prompt("Skopiuj wynik:", full); });
      } else {
        window.prompt("Skopiuj wynik:", full);
      }
    });

    update();
  }

  function boot(){
    var nodes = document.querySelectorAll("[data-rola-dog-growth]");
    for(var i = 0; i < nodes.length; i++){
      if(nodes[i].getAttribute("data-rc-init")) continue;
      nodes[i].setAttribute("data-rc-init", "1");
      init(nodes[i]);
    }
  }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})(typeof window !== "undefined" ? window : this);
